import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const NavCreateIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.34 5.56002L12.88 0.640024C12.34 0.320024 11.66 0.320024 11.12 0.640024L2.66004 5.56002C2.12004 5.87002 1.79004 6.45002 1.79004 7.07002V16.92C1.79004 17.54 2.12004 18.12 2.66004 18.43L11.12 23.35C11.66 23.67 12.34 23.66 12.88 23.35L21.34 18.43C21.88 18.12 22.21 17.54 22.21 16.92V7.08002C22.21 6.46002 21.88 5.88002 21.34 5.57002V5.56002ZM20.71 16.92C20.71 17.01 20.66 17.09 20.59 17.14L12.13 22.06C12.05 22.11 11.96 22.1 11.88 22.06L3.42004 17.14C3.34004 17.1 3.30004 17.01 3.30004 16.92V7.08002C3.30004 6.99002 3.35004 6.91002 3.42004 6.86002L11.87 1.94002C11.95 1.90002 12.04 1.89002 12.12 1.94002L20.58 6.86002C20.66 6.91002 20.71 6.99002 20.71 7.08002V16.93V16.92Z"
        fill={color}
      />
      <path
        d="M18 11.38H12.62V6C12.62 5.65 12.34 5.38 12 5.38C11.66 5.38 11.38 5.66 11.38 6V11.38H6C5.65 11.38 5.38 11.66 5.38 12C5.38 12.34 5.66 12.62 6 12.62H11.38V18C11.38 18.34 11.66 18.62 12 18.62C12.34 18.62 12.62 18.34 12.62 18V12.62H18C18.34 12.62 18.62 12.34 18.62 12C18.62 11.66 18.34 11.38 18 11.38Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

NavCreateIcon.displayName = 'NavCreateIcon';
